module.exports = __webpack_public_path__ + "4128202a176b10fa597f1221f8e7e4cd.svg";